import { createTagRepeat, optimizeTemplateHTML } from '../../lib/utils.js';
var calendarWeeksTemplate = optimizeTemplateHTML("<div class=\"calendar-weeks\">\n  <div class=\"days-of-week\"><span class=\"dow\"></span></div>\n  <div class=\"weeks\">".concat(createTagRepeat('span', 6, {
  class: 'week'
}), "</div>\n</div>"));
export default calendarWeeksTemplate;